import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { Box, useTheme, alpha } from '@mui/material'; // Import alpha from MUI system

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
}

const Scrollbar: FC<ScrollbarProps> = ({ className, children, ...rest }) => {
  const theme = useTheme();

  return (
    <Scrollbars
      autoHide
      renderThumbVertical={() => {
        return (
          <Box
            sx={{
              width: 5,
              background: alpha(theme.palette.common.black, 0.1), // Use theme.palette.common.black
              borderRadius: theme.shape.borderRadius, // Corrected to use the default borderRadius
              transition: theme.transitions.create(['background']),

              '&:hover': {
                background: alpha(theme.palette.common.black, 0.3) // Use common.black with transparency
              }
            }}
          />
        );
      }}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

Scrollbar.propTypes = {
  children: PropTypes.node as any,
  className: PropTypes.string
};

export default Scrollbar;
